<template>
  <b-modal
    ref="modal"
    :hide-header-close="hideHeaderClose"
    :modal-class="concatModalClass"
    :size="modalSize"
    @hide="handleHide"
    hide-footer
    :visible="visible"
    :title="title"
  >
    <h5 class="first-message" v-html="labelsResource.firstMessage"></h5>

    <div class="benefits row">
      <h1 class="col-lg-12 benefits-title">
        {{ labelsResource.benefitsTitle }}
      </h1>
      <ul class="list-of-benefits col-md-6">
        <li
          class="benefits-item"
          v-for="(item, index) in benefits.firstRow"
          :key="index + 1"
        >
          {{ item }}
        </li>
      </ul>
      <ul class="list-of-benefits col-md-6">
        <li
          class="benefits-item"
          v-for="(item, index) in benefits.secondRow"
          :key="index + 2"
        >
          {{ item }}
        </li>
      </ul>
    </div>

    <div class="row" v-if="isAdmin">
      <button @click="openEnterprisePlanPage" class="btn">
        {{ labelsResource.promoButton }}
      </button>
    </div>
    <h5 v-if="isManager" class="manager-message">
      <i class="material-icons material-icons-info">
        info
      </i>
      {{ labelsResource.managerMessage }}
    </h5>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { isManager, isAdmin } from '@/service/user'

export default {
  props: {
    visible: {
      required: false,
      type: Boolean,
      default: false,
    },
    hideHeaderClose: {
      required: false,
      type: Boolean,
      default: false,
    },
    modalClass: {
      required: false,
      type: String,
      default: '',
    },
    modalSize: {
      required: false,
      type: String,
      default: 'lg',
    },
    title: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      classFix: null,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labelsResource() {
      return this.resources.component.modalPlans
    },
    concatModalClass() {
      return `${this.modalClass} modal-plans`
    },
    benefits() {
      let benefits = {}
      let benefitsResources = this.labelsResource.benefits

      const firstRowKeys = [
        'benefitsOne',
        'benefitsTwo',
        'benefitsThree',
        'benefitsFour',
        'benefits12',
        'benefitsFive',
        'benefitsSix',
        'benefitsEleven',
      ]
      const secondRowKeys = [
        'benefitsNine',
        'benefitsSeven',
        'benefits13',
        'benefits14',
        'benefitsEigth',
        // 'benefitsTen',
        // 'benefits15',
        'benefits16',
      ]

      benefits['firstRow'] = firstRowKeys.map(key => benefitsResources[key])
      benefits['secondRow'] = secondRowKeys.map(key => benefitsResources[key])

      return benefits
    },
    isManager() {
      return isManager()
    },
    isAdmin() {
      return isAdmin()
    },
  },
  mounted() {
    this.upgrade()
  },
  methods: {
    upgrade() {
      this.$refs.modal.$on('shown', () => {
        this.$root.$emit('track', {
          event: 'Tentou acesso feature bloqueada',
          data: {
            category: 'Upgrade',
          },
        })
      })
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    handleHide() {
      this.$refs.modal.hide()
      this.$emit('hide', ...arguments)
    },
    openEnterprisePlanPage() {
      this.$router.push({
        name: 'account.licenses',
        params: { period: 'monthly' },
      })
      this.$root.$emit('track', {
        event: 'Clicou em obter empresarial',
        data: {
          category: 'Upgrade',
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.modal-plans {
  &.fix-175 .modal-dialog {
    @media (min-width: 992px) {
      transform: translateX(175px) !important;
    }
  }

  &.fix-33 .modal-dialog {
    transform: translateX(33px) !important;
  }

  .modal-content {
    min-height: 593px;
    border-radius: 8px;
    border: 1px solid rgba(37, 51, 99, 0.1);
  }

  .modal-body {
    padding-top: 18px;
    .first-message {
      color: map-get($theme-colors, 'gray03');
      font-size: 18px;

      b {
        color: map-get($theme-colors, 'primary');
      }
    }

    .manager-message {
      padding-top: 100px;
      font-size: 22px;
      color: map-get($theme-colors, 'red03');
    }

    .benefits {
      margin-top: 64px;

      .list-of-benefits {
        padding-left: 35px;
        .benefits-item {
          color: map-get($theme-colors, 'septenary');
          font-size: 16px;

          &:not(:first-of-type) {
            padding-top: 10px;
          }
        }
      }

      .benefits-title {
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 20px;
        color: map-get($theme-colors, 'primary');
      }
    }

    .btn {
      background-color: map-get($theme-colors, 'red02');
      color: map-get($theme-colors, 'white');
      font-weight: 500;
      height: 55px;
      margin: 66px auto 74px;
      width: 270px;

      &:hover {
        outline: none;
      }
    }

    .material-icons-info {
      padding: 0 10px;
    }
  }
}
</style>
